import { handleBookNow, handleSelectTimeSlot, handleReschedule } from './handlers.js';
import { initRender } from './render.js';

export function initBooking() {
	initRender();
	handleSelectTimeSlot();
	handleBookNow();
	handleReschedule();
}
